import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmptyComponent } from './empty/empty.component';
import { HomeComponent } from './home/home.component';
import { RiskDiagnosisComponent } from './risk-diagnosis/risk-diagnosis.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { DiagnosticCaptureComponent } from './diagnostic-capture/diagnostic-capture.component';
import { DiagnosticQuizComponent } from './diagnostic-quiz/diagnostic-quiz.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'inicio',
        component: EmptyComponent
      },
      {
        path: 'objetivos',
        component: EmptyComponent
      },
      {
        path: 'riesgos',
        component: EmptyComponent
      },
      {
        path: 'consentimiento',
        component: EmptyComponent
      },
      {
        path: 'acciones',
        component: EmptyComponent
      },
      {
        path: 'directorio',
        component: EmptyComponent
      }
    ]
  },
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'diagnostico',
    component: DiagnosticCaptureComponent
  },
  {
    path: 'encuesta',
    component: DiagnosticQuizComponent
  },
  {
    path: 'estadisticas',
    component: StatisticsComponent
  },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
